// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"271":"4ec50d51","434":"47295abe","794":"d12e861a","886":"e2e9eca9"}[chunkId] + ".css";
};